<template>
    <div class=" ">
        <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
            id="loader">
            <b-container fluid style="padding-top: 100px;text-align:left">
                <b-row>
                    <b-col class="headerF">
                        <HeaderFixed />
                    </b-col>
                    <b-col class="headerM">
                        <HeaderMobile />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-breadcrumb style=" background-color: #e9ecef78;">
                            <b-breadcrumb-item href="#home">
                                <router-link to="/">
                                    <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                                    Home
                                </router-link>
                            </b-breadcrumb-item>
                            <b-breadcrumb-item href="#" active>Composite Billing</b-breadcrumb-item>
                        </b-breadcrumb>
                    </b-col>
                </b-row>
                <b-row class="d-flex justify-content-center align-items-center"
                    style="min-height: calc(100vh - 200px);">
                    <b-col cols="12" sm="10" md="6" lg="4">
                        <b-card class="shadow p3" style="border-radius: 12px;">
                            <!-- Card Header -->
                            <div class="text-center mb-2">
                                <h4 class="font-weight-bold">Composite Billing Login</h4>
                                <!-- <p class="text-muted small">Enter your mobile number and the OTP sent to your registered contact</p> -->
                                <hr>
                            </div>
                            <b-form @submit.prevent="handleFormSubmit">
                                <!-- for mobile no -->
                                <b-form-group label="Enter Mobile Number" label-for="mobileNo">
                                    <b-input-group>
                                        <b-form-input id="mobileNo" v-model="mobileNo" type="tel"
                                            placeholder="Enter 10-Digit Mobile Number" maxlength="10" required
                                            :state="mobileNoState" :disabled="otpSent || alreadyLoggedIn">
                                        </b-form-input>
                                        <b-form-invalid-feedback>
                                            Please enter a valid 10-digit mobile number!
                                        </b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                                <!-- OTP sent info + Change link -->
                                <div v-if="otpSent && !alreadyLoggedIn" class="text-right">
                                    <b-link class="small text-primary" @click="changeMobile">Change</b-link>
                                </div>
                                <b-form-group v-if="otpSent && !alreadyLoggedIn" label="Enter OTP" label-for="sendOtp">
                                    <b-input-group>
                                        <b-form-input id="sendOtp" v-model="sendOtp" :type="showOtp ? 'text' : 'password'"
                                            Placeholder="Enter 6-Digit OTP" maxlength="6" required :state="otpState">
                                        </b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="outline-secondary" @click="showOtp = !showOtp" tabindex="-1">
                                                <b-icon :icon="showOtp ? 'eye-slash' : 'eye'" />
                                            </b-button>
                                        </b-input-group-append>
                                        <b-form-invalid-feedback>
                                            Please enter a valid 6-digit OTP.
                                        </b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                                <!-- for resend otp -->
                                <div v-if="otpSent && !alreadyLoggedIn" class="text-right mt-0">
                                    <b-link @click="resendOtp" class="small text-primary">Resend OTP</b-link>
                                </div>
                                <!-- submit button -->
                                <b-button v-if="!alreadyLoggedIn" type="submit" variant="primary" block class="mt-1"
                                    :disabled="sendingOtp || loading">
                                    <b-spinner small v-if="sendingOtp || loading" class="mr-2" />
                                    <span v-if="sendingOtp">Sending OTP...</span>
                                    <span v-else-if="loading">Verifying...</span>
                                    <span v-else-if="!otpSent">Send OTP</span>
                                    <span v-else>Verify OTP</span>
                                </b-button>
                                <!-- force log out button -->
                                 <!-- force logout: step 1 — send OTP button -->
                                <b-button
                                    v-if="alreadyLoggedIn && !forceOtpSent"
                                    variant="danger"
                                    block
                                    class="mt-1"
                                    :disabled="forcingLogout"
                                    @click="forceLogout">
                                    <b-spinner small v-if="forcingLogout" class="mr-2" />
                                    <span v-if="forcingLogout">Sending OTP...</span>
                                    <span v-else>Force Logout & Send OTP</span>
                                </b-button>

                                <!-- force logout: step 2 — enter OTP -->
                                <b-form-group v-if="alreadyLoggedIn && forceOtpSent" label="Enter OTP to Force Logout" label-for="otpNoFL" class="mt-2">
                                    <b-input-group>
                                        <b-form-input
                                            id="otpNoFL"
                                            v-model="forceOtp"
                                            :type="showForceOtp ? 'text' : 'password'"
                                            placeholder="Enter 6-Digit OTP"
                                            maxlength="6"
                                            :state="forceOtpValidating ? /^\d{6}$/.test(forceOtp) : null">
                                        </b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="outline-secondary" @click="showForceOtp = !showForceOtp" tabindex="-1">
                                                <b-icon :icon="showForceOtp ? 'eye-slash' : 'eye'" />
                                            </b-button>
                                        </b-input-group-append>
                                        <b-form-invalid-feedback>
                                            Please enter a valid 6-digit OTP.
                                        </b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>

                                <!-- force logout: step 2 — verify button -->
                                <b-button
                                    v-if="alreadyLoggedIn && forceOtpSent"
                                    variant="danger"
                                    block
                                    class="mt-1"
                                    :disabled="verifyingForceLogout"
                                    @click="verifyForceLogout">
                                    <b-spinner small v-if="verifyingForceLogout" class="mr-2" />
                                    <span v-if="verifyingForceLogout">Verifying...</span>
                                    <span v-else>Verify & Force Logout</span>
                                </b-button>

                                <!-- Cancel / change number while alreadyLoggedIn -->
                                <b-button
                                    v-if="alreadyLoggedIn"
                                    variant="outline-secondary"
                                    block
                                    class="mt-1"
                                    @click="changeMobile">
                                    Use Different Number
                                </b-button>
                            </b-form>
                            <!-- show alert msg -->
                            <b-alert v-if="alertMsg" :variant="alertVariant" show class="mt-2 mb-0" dismissible
                                @dismissed="alertMsg = ''">
                                <span style="font-size: 0.8rem;">{{ alertMsg }}</span>
                            </b-alert>
                        </b-card>
                    </b-col>
                </b-row>
            </b-container>
        </b-overlay>
    </div>
</template>
<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

export default {
    name: 'CompositeBilling',
    components: {

        'HeaderFixed': HeaderFixed,
        'HeaderMobile': HeaderMobile
    },
    data() {
        return {
            show: false,
            otpSent: false,
            otpValidating: false,
            alreadyLoggedIn: false,
            forceOtpSent: false,        
            forceOtp: '',               
            showForceOtp: false,        
            forceOtpValidating: false,  
            verifyingForceLogout: false,
            forcingLogout: false,
            sendingOtp: false,
            submitted: false,
            mobileNo: '',
            sendOtp: '',
            showOtp: false,
            loading: false,
            alertVariant: 'success',
            alertMsg: '',
            alertTimeout: null,
            userName: ''
        }
    },
    computed: {
        mobileNoState() {
            if (!this.mobileNo) return null
            return /^[6-9]\d{9}$/.test(this.mobileNo) ? true : false
        },
        otpState() {
            if (!this.otpValidating) return null
            return /^\d{6}$/.test(this.sendOtp) ? true : false
        }
    },
    methods: {
        async handleFormSubmit() {
            if (!this.otpSent) {
                await this.sendOtpHandler()
            } else {
                await this.handleSubmit()
            }
        },
        // send otp
        // STEP 1: Send OTP
        async sendOtpHandler() {
            // this.submitted = true
            if (!this.mobileNoState) return

            this.sendingOtp = true
            this.alertMsg = ''

            let data = JSON.stringify({
                "mobileNo": this.mobileNo,
                "type": "new",
                "src": "composite"
            });

            let config = {
                method: 'post',
                url: this.$urlMyBijulee + '/auth/login',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            try {
                axios.request(config)
                    .then((response) => {
                        if (response.data.status == "success") {
                            // parent.$bvToast.toast('OTP Sent Successfully !', {
                            //     title: `Success`,
                            //     variant: 'success',
                            //     solid: true
                            // });
                            this.otpSent = true
                            this.alertVariant = 'success'
                            this.alertMsg = `OTP sent successfully to +91-${this.mobileNo}`
                        }
                        else if (response.data.status == "error" && response.data.message == "already logged in") {
                            this.alreadyLoggedIn = true
                            this.otpSent = false
                            this.alertVariant = 'danger'
                            this.alertMsg = `This number is already logged in on another device. 
                            Click "Force Logout & Send OTP" to terminate that session and continue.`

                        }
                        else if (response.data.status == "error") {
                            this.alertVariant = 'danger'
                            this.alertMsg = response.data.message || 'Failed to send OTP. Please try again.'
                            // document.getElementById("errorMsg").innerHTML = response.data.message;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } catch (err) {
                this.alertVariant = 'danger'
                this.alertMsg = 'Failed to send OTP. Please try again.'
            } finally {
                this.sendingOtp = false
            }
        },
        // force logout and auto-send otp
        // force logout step 1 — sends OTP via portal-fl
        async forceLogout() {
            this.forcingLogout = true
            this.alertMsg = ''

            let data = JSON.stringify({
                "mobileNo": this.mobileNo,
                "type": "new",
                "src": "portal-fl"
            });

            let config = {
                method: 'post',
                url: this.$urlMyBijulee + '/auth/login',
                headers: { 'Content-Type': 'application/json' },
                data: data
            };

            try {
                const response = await axios.request(config)
                if (response.data.status === 'success') {
                    this.forceOtpSent = true      // ← show OTP input + verify button
                    this.forceOtp = ''
                    this.forceOtpValidating = false
                    this.alertVariant = 'success'
                    this.alertMsg = `OTP sent to +91-${this.mobileNo}. Enter it below to force logout.`
                } else {
                    this.alertVariant = 'danger'
                    this.alertMsg = response.data.message || 'Failed to send OTP. Please try again.'
                }
            } catch (err) {
                console.error(err)
                this.alertVariant = 'danger'
                this.alertMsg = 'Failed to send OTP. Please try again.'
            } finally {
                this.forcingLogout = false
            }
        },

        // force logout step 2 — verifies OTP and calls /auth/forceLogout
        async verifyForceLogout() {
            this.forceOtpValidating = true
            if (!/^\d{6}$/.test(this.forceOtp)) return

            this.verifyingForceLogout = true
            this.show = true
            this.alertMsg = ''

            let data = JSON.stringify({
                "mobileNo": this.mobileNo,
                "otpNo": this.forceOtp
            });

            let config = {
                method: 'post',
                url: this.$urlMyBijulee + '/auth/forceLogout',
                headers: { 'Content-Type': 'application/json' },
                data: data
            };

            try {
                const response = await axios.request(config)
                if (response.data.status === 'success') {
                    // reset everything back to clean login state
                    this.alreadyLoggedIn = false
                    this.forceOtpSent = false
                    this.forceOtp = ''
                    this.forceOtpValidating = false
                    this.otpSent = false
                    this.sendOtp = ''
                    this.otpValidating = false
                    this.alertVariant = 'success'
                    this.alertMsg = 'Force logout successful! You can now log in.'
                } else {
                    this.alertVariant = 'danger'
                    this.alertMsg = response.data.message || 'Invalid OTP. Please try again.'
                }
            } catch (err) {
                console.error(err)
                this.alertVariant = 'danger'
                this.alertMsg = 'Force logout failed. Please try again.'
            } finally {
                this.verifyingForceLogout = false
                this.show = false
            }
        },
        // verify otp
        async handleSubmit() {
            this.otpValidating  = true;
            if (!this.otpState) return

            let data = JSON.stringify({
                "mobileNo": this.mobileNo,
                "otpNo": this.sendOtp,
                "src":"composite"
            });

            let config = {
                method: 'post',
                url: this.$urlMyBijulee+'/auth/otp/verify',
                headers: { 
                'Content-Type': 'application/json'
                },
                data : data
            };

            this.loading = true;
            this.show = true;
            try {
                const response = await axios.request(config); 
        
                if (response.data.status == "success") {
                    sessionStorage.setItem("accessToken", response.data.accessToken);
                    sessionStorage.setItem("consList", JSON.stringify(response.data.consList));
                    sessionStorage.setItem("mobile", this.mobileNo);
                    sessionStorage.setItem("userName", response.data.consName); 
                    
                    this.alertVariant = 'success';
                    this.alertMsg = 'OTP verified successfully!';
                    this.show = false;
                    window.location.href = "/website/CompositeBillingDashboard";
                } else {
                    this.alertVariant = 'danger';
                    this.alertMsg = response.data.message || 'Invalid OTP. Please try again.';
                }
            } catch (err) {
                this.alertVariant = 'danger'
                this.alertMsg = 'Invalid OTP. Please try again.'
            } finally {
                this.loading = false
            }
        },
        async resendOtp() {
            let data = JSON.stringify({
                "mobileNo": this.mobileNo,
                "type": "old",
                "src" : "composite"
            });
            let config = {
                method: 'post',
                url: this.$urlMyBijulee+'/auth/login',
                headers: { 
                'Content-Type': 'application/json'
                },
                data : data
            };
            try {
                this.loading = true;
                this.sendOtp = '';
                this.otpValidating  = false;
                this.alertMsg = '';

                axios.request(config)
                .then((response) => {
                    if (response.data.status == "success") {
                        this.alertVariant = 'success';
                        this.alertMsg = 'A new OTP has been sent to your registered contact.'
                    }
                    else {
                        this.alertVariant = 'danger'
                        this.alertMsg = 'Failed to resend OTP. Please try again.'
                    }
                });
            } catch (err) {
                this.alertVariant = 'danger'
                this.alertMsg = 'Failed to resend OTP. Please try again.'
            } finally {
                this.loading = false
            }
        },
        changeMobile() {
            this.otpSent = false
            this.alreadyLoggedIn = false
            this.sendOtp = ''
            this.otpValidating  = false
            this.alertMsg = ''
            this.forceOtpSent = false       
            this.forceOtp = ''               
            this.forceOtpValidating = false  
        }
    },
    watch: {
        alertMsg(val) {
            if (this.alertTimeout) clearTimeout(this.alertTimeout)
            if (val) {
                this.alertTimeout = setTimeout(() => {
                    this.alertMsg = ''
                }, 10000)  // 10 seconds — adjust as needed
            }
        }
    }
}
</script>
<style scoped="true">
.bg-light {
    background-color: #f0f2f5 !important;
}

.b-card {
    border: none;
}

.blink_me {
    animation: blinker 1s linear infinite;
    font-weight: 600;
}

td {
    padding: 0.3rem;
}

.label {
    font-weight: 600;
}

.data {
    font-weight: 600;
    color: #ff5722;
    font-size: 1.2rem;
}

.hideDetails {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s linear;
    box-shadow: 2px 2px 10px 2px #bdbdbd;
    padding: 1rem;
}

.showDetails {
    visibility: visible;
    opacity: 1;
}

hr {
    margin-top: 5px;
    margin-bottom: 5px;
}

.go:focus {
    box-shadow: none;
}

.paddingRow {
    padding: 0.7rem;
}

.headerF {
    display: block;
}

.headerM {
    display: none;
}

.paddingLeft30px {
    padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF {
        display: none;
    }

    .headerM {
        display: block;
    }

    .paddingLeft30px {
        padding-left: 0px;
    }
}
</style>